/* eslint-disable no-console */
import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import TypeAheadSearchWrapper from './TypeAheadSearch.style';


class TypeAheadSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      recipients: [],
      name: '',
      email: '',
      isLoading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleTextInput = this.handleTextInput.bind(this);
  }

  handleChange(evt) {
    if (evt[0]) {
      const lastItem = evt[evt.length - 1];
      const emailList = evt.map(user => { return { name: user.fullName, email: user.email }});
      this.setState(
        {
          name: lastItem.fullName,
          email: lastItem.email,
          recipients: emailList
        },
        () => {
          this.props.handleNameEmail(this.state.name, this.state.email, this.state.recipients);
        }
      );
    }
  }

  handleTextInput(evt) {
    if (evt.length > 2) {
      this.setState({
        isLoading: true
      });
      axios
        .post(
          `${process.env.REACT_APP_AD_SEARCH_API}`,
          { nameSegment: evt },
          {
            headers: {
              Authorization: `Bearer ${window.sessionStorage.accessToken}`,
              'Content-Type': 'application/json'
            }
          }
        )
        .then(res => {
          this.setState({
            data: res.data.data.users,
            isLoading: false
          });
        })
        .catch(err => {
          console.log(err);
          this.setState({
            isLoading: false
          });
        });
    }
  }

  render() {
    const { isLoading } = this.state;
    const options = this.state.data;
    const filterByFields = ['email', 'displayName', 'fullName', 'cn'];
    return (
      <TypeAheadSearchWrapper>
        <AsyncTypeahead
          id="namesearch"
          inputProps={{ 'aria-label': 'Name Search' }}
          filterBy={filterByFields}
          labelKey="displayName"
          options={options}
          placeholder={this.props.placeholder}
          multiple
          onChange={this.handleChange}
          minLength={3}
          onSearch={this.handleTextInput}
          isLoading={isLoading}
          className="ncss-select-menu"
          renderMenuItemChildren={option => (
            <div>
              {option.displayName}
              <div className="sub-text">{option.email}</div>
            </div>
          )}
        />
      </TypeAheadSearchWrapper>
    );
  }
}

TypeAheadSearch.propTypes = {
  placeholder: PropTypes.string,
  handleNameEmail: PropTypes.func.isRequired,
};

TypeAheadSearch.defaultProps = {
  placeholder: 'Enter name...',
};

export default TypeAheadSearch;


// WEBPACK FOOTER //
// ./src/components/TypeAheadSearch/TypeAheadSearch.js